// Add your constant here, any text that you use in our application,
export const VALIDATION_CONSTANTS = {
  NAME: /^[A-Za-z\d @$!%*?&\s\.,;:!(){}[\]\"\'<>\-=_+]*$/,
  FIRST_LAST_NAME: /^[A-Za-z\s]*$/,
  EMAIL:
    /^(?!.*\.\.)(?!.*\.$)(?!^\.)([a-zA-Z0-9._%+-]+)@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  CONTACT_NUMBER: /^\d{10}$/,
  ID: /^[a-zA-Z0-9]*$/,
  CHARACTER: /^[a-zA-Z\s]*$/,
  NUMERIC: /^\d+$/,
  WEBSITE: /^www\.[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
  FAX_ID: /^[a-zA-Z0-9._-]{3,50}$/,
  ZIP_CODE: /^\d{5}(-\d{4})?$/,
  US_STATE:
    /^(?:A[LKZ]|C[AOT]|D[CE]|FL|GA|HI|I[DLNA]|K[SY]|LA|M[EHDAINSOT]|N[EVHJMCY]|O[HKR]|P[A]|RI|S[CD]|T[NX]|UT|V[AIT]|W[AIVY])$/,
  ADDRESS: /^[a-zA-Z0-9\s]+$/,
  STRICT_CHAR_PLUS_NUMB_WITH_LIMIT_10: /^(?=.*[A-Z])(?=.*[0-9])[A-Z0-9]{1,10}$/, // REGEX FOR CHAR + NUMBER AND IN BETWEEN TXT NO SPACE ACCEPT AND LIMIT UPTO 10 CHAR
  CHARACTER_WITH_LIMIT_40: /^[a-zA-Z\s]{1,40}$/,
  LIMIT_20: /^.{1,20}$/,
  ACCEPT_CHAR_AND_NUMBER: /^[A-Za-z0-9 ]{1,40}$/,
  SKU_VALIDATION: /^[A-Za-z0-9]{5,10}$/,
  LIMIT_10: /^.{1,10}$/,

  // Add more text as needed
};
